<button type="button" class="btn btn-primary" data-testid="swms-show-form-btn" (click)="openDialog()">
  <fa-icon [icon]="['fas', 'hard-hat']"></fa-icon>
  <span class="pl-1">{{ 'show_swms' | translate }}</span>
</button>
